var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PlayerStatTilesPanel',_vm._l((_vm.academics),function(academicStat){return _c('div',[_c('PlayerStatTile',{attrs:{"stat-name":academicStat.name,"stat-value":academicStat.value,"thumbnail-image":academicStat.thumbnailImage,"video":academicStat.video}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }